const getAlgoliaSuggestionIndex = (
  mainIndexName = window.drupalSettings.sgna_search.indexName,
) => {
  // eslint-disable-next-line no-console
  return `${mainIndexName}_query_suggestions`;
};

export default getAlgoliaSuggestionIndex;
